import React, { Component, useState } from 'react';
import { FormattedMessageWrappedInSpan } from '../../../components/misc';



const JobPhotographer = ({setShowJob, showJob, job, ...props}) => {

  return (
    <>
    { job == "photographer" &&
    <div className="container-960 container-page">
      <h2>
        <FormattedMessageWrappedInSpan id="jobsPage.photographer.headline" defaultMessage="Placeholder" />
      </h2>
      <br />
      <br />
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.photographer.aboutus.title" defaultMessage="Placeholder" />
      </b>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.photographer.aboutus.text"
          defaultMessage="Placeholder"
          values={{
            br: <br />,
          }}
        />
      </p>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.photographer.needs.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.photographer.needs.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.photographer.needs.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.photographer.needs.bullet3" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.photographer.needs.bullet4" defaultMessage="Placeholder" />
          </li>
        </ul>
        </span>
        <br/>
        <p>
          <FormattedMessageWrappedInSpan id="jobsPage.photographer.welcome_part1" defaultMessage="Placeholder"/>
          <b><a href="https://sites.google.com/sportograf.com/freelancer-sportograf/home" target="_blank"><FormattedMessageWrappedInSpan id="jobsPage.photographer.link" defaultMessage="Placeholder"/></a></b>
          <FormattedMessageWrappedInSpan id="jobsPage.photographer.welcome_part2" defaultMessage="Placeholder"/>
        </p>
      <br />
      <button className="secondary" onClick={() => setShowJob(!showJob)}>
        <FormattedMessageWrappedInSpan
          id="jobsPage.back"
          defaultMessage="back"
        />
      </button>

      </div>
      }
      </>
  )
}

export default JobPhotographer
